// extracted by mini-css-extract-plugin
export default {"features":"Features_features__Z0ymW","featuresWrap":"Features_featuresWrap__aM7Kq","block":"Features_block__Ku1TE","content":"Features_content__PZy1J"};